import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import firebase from 'firebase';
import {
  Form,
  Collapse,
  Navbar,
  Nav,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Col,
  Row,
} from "reactstrap";
import { Menu, MoreVertical, User, Lock, LogOut } from "react-feather";
import Select from "react-select/";
import { RootState } from "../../../redux/storeConfig/store";
import { setCompany } from "../../../redux/actions/company";
import logout from "../../../services/logout";
import { COMPANY_STATUS } from "../../../Constants";
import userImage from "../../../assets/img/portrait/small/default-avatar.png";
import { priceToBRLCurrency } from '../../../utility/support';

const ThemeNavbar = (props: any) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const user = useSelector((state: RootState) => state.contributor);
  const invoices = useSelector((state: RootState) => state.invoices);
  const showNavbar = useSelector((state: RootState) => state.customizer.navbar);
  const company = useSelector((state: RootState) => state.company);

  const unsubscribeRef = useRef<() => void>();
  const [availableBalance, setAvailableBalance] = useState<number>();
  const [isOpen, setIsOpen] = useState(false);
  const todayNum = new Date().getDay();
  const daysToFriday = 5 - (todayNum < 5 ? todayNum : todayNum - 7);

  useEffect(() => {
    if (unsubscribeRef.current) {
      unsubscribeRef.current();
    }

    if (company.id) {
      unsubscribeRef.current = firebase
        .firestore()
        .collection('wallets')
        .doc(company.id)
        .onSnapshot(snapshot => {
          if (snapshot.exists) {
            setAvailableBalance(Number(snapshot.data()?.availableBalance));
          } else {
            setAvailableBalance(undefined);
          }
        })
    }

    return unsubscribeRef.current;
  }, [company?.id]);

  const toggle = () => {
    setIsOpen(!isOpen);
  };

  const handleCompanyChange = (e: any) => {
    dispatch(setCompany(e.value));
  };

  return (
    <Navbar className="navbar navbar-expand-lg navbar-light bg-faded">
      <div className="container-fluid px-0">
        <div className="navbar-header">
          <Menu
            size={14}
            className="navbar-toggle d-lg-none float-left"
            onClick={() => props.toggleSidebarMenu("open")}
            data-toggle="collapse"
          />

          {showNavbar && (
            <Form className="navbar-form mt-1 float-left" role="search" id="form_company_select">
              <Row>
                <h4>
                  <strong>Empresa: </strong>
                </h4>
                <Col style={{ minWidth: 256 }}>
                  <Select
                    className="basic-single"
                    classNamePrefix="select"
                    name="company"
                    options={user.empresas.map((company) => ({
                      label: company.nomeEmpresa,
                      value: company,
                    }))}
                    defaultValue={{
                      label: company.nomeEmpresa,
                      value: company,
                    }}
                    onChange={handleCompanyChange}
                  />
                </Col>
                  <Col>
                    {
                      availableBalance !== undefined &&
                      <p>
                        Saldo disponível: <b>{priceToBRLCurrency(availableBalance)}</b>
                      </p>
                    }
                  </Col>
              </Row>
            </Form>
          )}

          <MoreVertical
            className="mt-1 navbar-toggler black no-border float-right"
            size={50}
            onClick={toggle}
          />
        </div>

        {invoices.length > 0 && (
          <div>
            {company.status === COMPANY_STATUS.BLOCKED ? (
              <p>
                <strong>Seu serviço está desabilitado. Por favor, verifique suas faturas.</strong>
              </p>
            ) : (
              <div>
                {todayNum !== 5 && (
                  <p>
                    <strong>Há faturas em aberto!</strong> Seu serviço pode ser desabilitado em{" "}
                    {daysToFriday} dia(s).
                  </p>
                )}
              </div>
            )}
          </div>
        )}

        <div className="navbar-container">
          <Collapse isOpen={isOpen} navbar>
            <Nav className="ml-auto float-right" navbar>
              <UncontrolledDropdown nav inNavbar className="pr-1">
                <DropdownToggle nav>
                  <img
                    src={userImage}
                    style={{ background: "#eee" }}
                    alt="logged-in-user"
                    className="rounded-circle width-35"
                  />
                </DropdownToggle>
                <DropdownMenu right>
                  <DropdownItem>
                    <span className="font-small-3">{`${user.nome} ${user.sobrenome}`}</span>
                  </DropdownItem>
                  <DropdownItem divider />

                  <DropdownItem>
                    <User size={16} className="mr-1" /> Minha Conta
                  </DropdownItem>
                  <DropdownItem divider />

                  <DropdownItem>
                    <Lock size={16} className="mr-1" /> Bloquear Tela
                  </DropdownItem>
                  <DropdownItem onClick={() => logout(dispatch, history)}>
                    <LogOut size={16} className="mr-1" /> Sair
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
            </Nav>
          </Collapse>
        </div>
      </div>
    </Navbar>
  );
};

export default ThemeNavbar;
